import router from '../router'

const mutations = {
  // synchronous
  SET_CURRENT_TAB(state, payload) {
    state.currentTab = payload
  },

  SET_HABITS(state, payload) {
    state.habits = payload
  },

  SET_SELECTED_HABIT(state, payload) {
    state.selectedHabit = payload
  },

  SET_LOGS(state, payload) {
    state.logs = payload
  },

  DELETE_LOG(state, logIndex) {
    const logs = [...state.logs]
    logs.splice(logIndex, 1)
    state.logs = logs
  },

  SET_LOGS_COMPLETE(state, payload) {
    state.logsComplete = payload
  },

  SET_CATEGORIES(state, payload) {
    state.categories = payload
  },

  SET_SELECTED_CATEGORY(state, payload) {
    state.selectedCategory = payload
  },

  SET_MONTH_VIEW(state, payload) {
    state.monthView = payload
  },

  SET_SELECTED_MONTH(state, payload) {
    state.selectedMonth = payload
  },

  SET_SELECTED_MONTH_NAME(state, payload) {
    state.selectedMonthName = payload
  },

  SET_SELECTED_YEAR(state, payload) {
    state.selectedYear = payload
  },

  USER_DETAILS(state, userProfile) {
    state.loggedIn = true
    state.user = {
      id: userProfile.id,
      name: userProfile.name,
      account: userProfile.account,
      email: userProfile.email
    }
    if (router.history.current.name === 'Habits') return
    router.push('/habits')
  },

  LOGOUT(state) {
    state.loggedIn = false
    state.user = {}
    state.currentTab = 'tab1'
    router.push('/')
  }
}

export default mutations
